export interface OccupiedTimeInfo {
  id: string;
  fromTaskId: string;
  toTaskId: string;
  sourceTaskId: string;

  userId: string;

  startTimestamp: number;
  endTimestamp: number;

  durationInMin: number;

  type: OccupiedTimeType;
}

export enum OccupiedTimeType {
  TRAVEL_TIME = "TRAVEL_TIME",
  BREAK = "BREAK",
}
